import { render } from "./VUEFrameComponenteGraficoTensioneAssorbimento.vue?vue&type=template&id=57bda7e1"
import script from "./VUEFrameComponenteGraficoTensioneAssorbimento.vue?vue&type=script&lang=js"
export * from "./VUEFrameComponenteGraficoTensioneAssorbimento.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__